import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import clsx from 'clsx';

export type ProductListItemType = 'product' | 'product-with-presentations';
export type ProductListItemSize = 'md' | 'sm';

/**
 * Price display for the catalog card. Replaces the legacy `<pxw-product-price>`
 * `product-item` + `presentation-item` layouts. Dumb: receives `headlineDiscount`
 * already computed by the parent — see promotion-display split plan.
 */
@Component({
  selector: 'pxw-product-list-item-price',
  templateUrl: './product-list-item-price.component.html',
  styleUrls: ['./product-list-item-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, TagComponent, CurrencyFormatPipe],
})
export class ProductListItemPriceComponent {
  itemType = input.required<ProductListItemType>();
  price = input.required<number>();
  priceDiscount = input<number>();
  headlineDiscount = input<number>();
  size = input<ProductListItemSize>('md');

  hasHeadline = computed(() => (this.headlineDiscount() ?? 0) > 0);

  hasPriceDiscount = computed(() => {
    const discount = this.priceDiscount();
    const price = this.price();
    const itemType = this.itemType();

    if (itemType === 'product-with-presentations') {
      return false;
    }
    return !!discount && discount < price;
  });

  @HostBinding('class')
  get classNames() {
    return clsx({
      'with-discount': this.hasPriceDiscount(),
      'size-sm': this.size() === 'sm',
    });
  }
}
